<template>
  <div v-view="handleInView" class="section-part" @click="onClick">
    <div class="container" :class="classes">
      <div v-if="showHeader" class="story-part-header" :style="headerStyles">
        <div class="title">{{ title }}</div>
        <div class="icon"><img :src="iconSrc" /></div>
      </div>
      <g-markdown class="story-part-body" :content="text" type="story-part" />
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      default: () => -1
    },
    partData: {
      type: Object,
      default: () => {}
    },
    hoverActive: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      show: false,
      uerLimitActive: false
    };
  },
  computed: {
    classes() {
      return {
        show: this.show,
        'hover-active': this.hoverActive,
        'user-limit-active': this.uerLimitActive,
        'header-visible': this.showHeader
      };
    },
    iconSrc() {
      let src = false;
      switch (this.partData.Type) {
        case 'Meddelande':
          src = require('@/assets/svg/icon-message.svg');
          break;
        case 'Bild':
          src = require('@/assets/svg/icon-camera.svg');
          break;
        case 'Stopp':
          src = require('@/assets/svg/icon-stop.svg');
          break;
        case 'Hjartkrossad':
          src = require('@/assets/svg/icon-broken-heart.svg');
          break;
        case 'Molnig':
          src = require('@/assets/svg/icon-cloud.svg');
          break;
      }
      return src;
    },
    headerStyles() {
      let color = '#F19460';

      switch (this.partData.Type) {
        case 'Meddelande':
          color = '#AAC8EA';
          break;
        case 'Bild':
          color = '#F19460';
          break;
        case 'Stopp':
          color = '#C26832';
          break;
        case 'Hjartkrossad':
          color = '#2B4A9A';
          break;
        case 'Molnig':
          color = '#EBBBCA';
          break;
      }

      return { backgroundColor: color };
    },
    showHeader() {
      return this.partData.Title || this.partData.Type;
    },
    title() {
      return this.partData.Title;
    },
    text() {
      return this.partData.Text;
    }
  },
  methods: {
    handleInView(e) {
      if (e.type === 'exit') {
        this.$emit('leaving', { visible: false, ...this.partData });
      } else if (e.type === 'enter') {
        this.$emit('entering', { visible: true, ...this.partData });
      } else if (e.type === 'progress') {
        this.$emit('moving', {
          pagePercentage: e.scrollPercent,
          percentage: e.percentCenter,
          index: this.index,
          ...this.partData
        });
      }

      if (!this.show && e.percentTop < 0.9) {
        this.show = true;
        this.$emit('animating-in', this.index);
      }

      /* if (this.partData.id === '2') {
        console.log(
          '***************************' +
            this.partData.id +
            '**********************************'
        );
        console.log(e.type); // 'enter', 'exit', 'progress'
        console.log(e.percentInView); // 0..1 how much element overlap the viewport
        console.log(e.percentTop); // 0..1 position of element at viewport 0 - above , 1 - below
        console.log(e.percentCenter); // 0..1 position the center of element at viewport 0 - center at viewport top, 1 - center at viewport bottom
        console.log(e.scrollPercent); // 0..1 current scroll position of page
        console.log(e.scrollValue); // 0..1 last scroll value (change of page scroll offset)
        console.log(e.target.rect); // element.getBoundingClientRect() result 
        console.log(
          '*************************************************************'
        );
      } */
    },
    inactivateUserLimit() {
      this.uerLimitActive = false;
    },
    activateUserLimit() {
      this.uerLimitActive = true;
    },
    onClick() {
      this.$emit('click', this.partData.id);
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}

.section-part {
  width: 100%;
}

.container {
  border: 6px dotted transparent;
  border-radius: 30px;
  opacity: 0;
  /*   overflow: hidden; */
  transform: translate(0, 50px);
  transition: opacity 0.5s ease-out, transform 0.5s ease-out;

  &.show {
    opacity: 1;
    transform: translate(0, 0);
  }

  &.header-visible {
    border-radius: 0;
  }

  &.hover-active {
    cursor: pointer;
  }

  &.hover-active:hover,
  &.user-limit-active {
    border: 6px dotted $green;
    border-radius: 36px;
  }
}

.story-part-header {
  align-items: center;
  border-radius: 30px;
  display: flex;
  justify-content: space-between;
  padding: 18px 30px 15px;

  .title {
    color: $white;
    font-family: 'Fugaz One';
    font-size: 16px;
    font-style: normal;
    font-weight: normal;
    letter-spacing: 0.05em;
    line-height: 140%;
    text-transform: uppercase;
  }

  .icon {
    img {
      display: block;
    }
  }
}

.story-part-body {
  background-color: $white;
  border-radius: 30px;
  padding: 15px 30px 20px;
}
</style>
